import React, { useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Modal,
  TextField,
  Typography
} from '@material-ui/core';

const ScanProductModal = (props) => {

  const [barcodeInput, setBarcodeInput] = useState("");
  const [productInfo, setProductInfo] = useState({});

  const checkBarcodeProduct = (e) => {
    setBarcodeInput(e.target.value);

    if(e.target.value.length > 3) {
      const scanInfo = props.products.find(product => product.barcode === e.target.value);
      if(scanInfo) {
        setProductInfo(scanInfo);
        setBarcodeInput("");
      }
    }
  };

  return (
    <Modal
      open={props.open}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '10%'
      }}
    >
      <Card>
        <CardHeader
          subheader="Get Products Information."
          title="Product Info"
        />
        <Divider />
        <CardContent>
          <TextField
            autoFocus
            style={{ width: 325 }}
            label="Scan Barcode"
            name="barcode"
            onChange={(event) => checkBarcodeProduct(event)}
            value={barcodeInput}
            variant="outlined"
          />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              height: 275,
              alignItems: 'center',
              justifyContent: 'center',
              marginTop: 15,
              gap: 10
            }}
            border={1}
            borderColor="grey.300"
            borderRadius={5}
          >
            { productInfo.id ?
              <React.Fragment>
                <Typography
                  color="textPrimary"
                  variant="h4"
                >
                  {productInfo.displayId}
                </Typography>
                <Typography
                  variant="h5"
                >
                  Name : {productInfo.name}
                </Typography>
                <Typography
                  variant="body1"
                >
                  Category : {productInfo.category}
                </Typography>
                <Typography
                  variant="body1"
                >
                  Company : {productInfo.company}
                </Typography>
                <Typography
                  variant="body1"
                >
                  Barcode : {productInfo.barcode}
                </Typography>
              </React.Fragment> :
              <Typography
                variant="body2"
                color="textSecondary"
                >
                Scan a barcode to view Product details
              </Typography>
            }
          </Box>
        </CardContent>
        <Divider />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            p: 1
          }}
        >
          <Button sx={{ mx: 1 }} color="primary" onClick={props.closeModal}>
            Close
          </Button>
        </Box>
      </Card>
    </Modal>
  )
};

export default ScanProductModal;